import { render, staticRenderFns } from "./Info.vue?vue&type=template&id=701bd1f2&scoped=true"
import script from "./Info.vue?vue&type=script&lang=js"
export * from "./Info.vue?vue&type=script&lang=js"
import style0 from "./Info.vue?vue&type=style&index=0&id=701bd1f2&prod&lang=scss"
import style1 from "./Info.vue?vue&type=style&index=1&id=701bd1f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701bd1f2",
  null
  
)

export default component.exports